import { MapPin, Clock, ArrowUpRight } from "lucide-react";

export const Location = ({ t }) => {
  const mapsQuery = encodeURIComponent("Bendito Tattoo, Playa del Carmen, Quintana Roo, Mexico");
  return (
    <section
      id="location"
      className="relative py-14 md:py-20 bg-bendito-surface border-t border-bendito-border"
      data-testid="location-section"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5 reveal">
            <div className="eyebrow mb-3">{t.location.eyebrow}</div>
            <h2 className="font-heading text-bendito-ink text-4xl md:text-5xl lg:text-6xl uppercase tracking-tight">
              <span className="ink-underline">{t.location.title}</span>
            </h2>
            <p className="text-bendito-muted mt-3">{t.location.sub}</p>

            <div className="mt-8 space-y-5">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-bendito-orange shrink-0 mt-0.5" strokeWidth={1.5} />
                <div>
                  <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-bendito-muted">
                    {t.location.eyebrow === "Encuéntranos" ? "Dirección" : "Address"}
                  </div>
                  <div className="text-bendito-ink mt-1">{t.location.address}</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-bendito-orange shrink-0 mt-0.5" strokeWidth={1.5} />
                <div>
                  <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-bendito-muted">
                    {t.location.eyebrow === "Encuéntranos" ? "Horario" : "Hours"}
                  </div>
                  <div className="text-bendito-ink mt-1">{t.location.hours}</div>
                </div>
              </div>
            </div>

            <a
              href="https://www.google.com/maps/place/Bendito+Tattoo/@20.6303157,-87.0715087,17z/data=!3m1!4b1!4m6!3m5!1s0x8f4e43a7a8541b63:0xfa73ee7e58b432e0!8m2!3d20.6303157!4d-87.0689338!16s%2Fg%2F11njg_jdfs?hl=es-419&entry=ttu"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 inline-flex items-center gap-2 bg-bendito-orange hover:bg-bendito-orangeDark text-black font-heading tracking-[0.22em] text-sm px-6 py-3 transition-colors"
              data-testid="location-directions-btn"
            >
              {t.location.directions}
              <ArrowUpRight size={16} />
            </a>
          </div>

          <div className="lg:col-span-7">
            <div className="aspect-[4/3] md:aspect-[16/10] border border-bendito-border overflow-hidden bg-bendito-bg">
              <iframe
                title="Bendito Tattoo location on Google Business Profile"
                src={`https://www.google.com/maps?q=${mapsQuery}&output=embed`}
                className="w-full h-full grayscale contrast-110"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                data-testid="location-map"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;
